export default __webpack_public_path__ + "static/media/thumbnail-m-chair@2x.b2bc9857.png";